import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Navigate } from 'react-router';

import '../Passport.css';

import Signup from './Signup';

class SignupContainer extends Component<any, any> {
  constructor(props: any){
    super(props);

    this.state = {
        loading: false,
        redirectToSignup: true,
        redirectToLanding: false,
        usernameError: "",
        emailError: "",
        passwordError: "",
        returnedError: "",
        confirmPasswordError: "",
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.processGoogleResponse = this.processGoogleResponse.bind(this);
    this.setError = this.setError.bind(this);
  }

  processGoogleResponse(res: any) {
    this.props.rootStore.profileStore.storeGoogleSignup(res);
  }

  setError(stateError: any) {
      this.setState(stateError);
  }

  handleSubmit = (email: string, username: string, password: string, confirm_password: string) => {
    const component = this;
    this.props.rootStore.profileStore.signUp(
        email,
        username,
        password,
        confirm_password,
        function(error: boolean, errorType: string, errorMessage: string) {
            if (error) {
                var errorState: any = {};
                errorState[errorType] = errorMessage
                component.setState(errorState);
                component.setState({
                    loading: false,
                    redirectToIndex: true
                })
            } else {
                component.setState({
                    loading: false,
                    redirectToSignup: true
                });
            }
        }
    );
  }

  render() {
    if (this.props.rootStore.profileStore.redirectTo) {
      const redirectTo = this.props.rootStore.profileStore.redirectTo;
      this.props.rootStore.profileStore.clearRedirect()
      return (<Navigate to={redirectTo} />);
    }

    return (<Signup 
      processGoogleResponse={this.processGoogleResponse} 
      handleSubmit={this.handleSubmit}
      status={this.props.rootStore.profileStore.status}
      statusMessage={this.props.rootStore.profileStore.statusMessage}
      usernameError={this.state.usernameError}
      passwordError={this.state.passwordError}
      confirmPasswordError={this.state.confirmPasswordError}
      returnedError={this.state.returnedError}
      emailError={this.state.emailError}
      setError={this.setError}
    />);
  }
}

export default observer(SignupContainer);
